import HealthInformationPage from "./HealthInformationPage";
export default HealthInformationPage;
